import IconBox from "../../iconboxes/IconBox";

export default function NamePhoneCell({classes, phone, name}) {
    return <div className={`${classes.cell_row} ${classes.cell_row_flex} ${classes.cell_row_name_phone}`}>
        {name}
        {phone && <IconBox type={'phone'} link={phone} workq={true}>
            <i className="ti ti-phone"></i>
        </IconBox>}
    </div>
}